import { createPersistedStore, storage } from '@connect-x-app/hybrid-utils';
import { SettingsItems, ThemePreference, TimeZone } from '@connect-x-app/shared-domain-models';
import { createJSONStorage } from 'zustand/middleware';

type SettingsState = {
  setSettings: (settings: SettingsItems) => void;
  setThemePreference: (themePreference: ThemePreference) => void;
  settings: SettingsItems;
};

export const useSettingsStore = createPersistedStore<SettingsState>(
  (set, _) => ({
    setSettings: settings => {
      set(state => ({
        settings: {
          ...state.settings,
          ...settings,
          preferences: {
            ...state.settings.preferences,
            ...(settings?.preferences || {}),
          },
        },
      }));
    },
    setThemePreference: themePreference => {
      set(state => ({
        settings: {
          ...state.settings,
          preferences: {
            ...state.settings?.preferences,
            themePreference,
          },
        },
      }));
    },
    settings: {
      preferences: { themePreference: ThemePreference.SYSTEM, timeZone: TimeZone.UTC },
      pushNotifications: [],
    },
  }),
  {
    name: 'settings-store',
    storage: createJSONStorage(() => storage),
  },
);
